import type { NextPage } from 'next'
import Link from 'next/link'
import BodyText from '../lib/components/body-text'
import PageHeader from '../lib/components/page-header'

const Login: NextPage = () => {
  return (
    <>
      <PageHeader title="Pricing" />
      <div className="mt-4">
        <BodyText>
          Purchasing credits are a way to help cover costs for running the plugin. Credit usage is{' '}
          <Link className="text-green-800 underline hover:text-green-600" href="/faq">
            correlated with AI model usage
          </Link>
          , but usually each generation will use 2 credits.
        </BodyText>
        <h3 className="mt-4">Buying more credits</h3>
        <BodyText>
          You can currently buy the following amounts of credits:
          </BodyText>
          <ul className="my-2 ml-6 list-disc text-sm font-light">
            <li>
              <strong>$5:</strong> 50 credits
            </li>
            <li>
              <strong>$10:</strong> 110 credits
            </li>
            <li>
              <strong>$15:</strong> 200 credits
            </li>
          </ul>
          <BodyText>
          You can purchase more credits after{' '}
          <Link className="text-green-800 underline hover:text-green-600" href="/login">
            logging in
          </Link>
          .
        </BodyText>
      </div>
    </>
  )
}

export default Login
